

































































































import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import api from "@/api";
import {
  ActivityApplyCreateOrUpdateDto,
  ActivityApplyFormSchemaDto,
  ActivitySignUpFormSchemaDto,
  VolunteerStatus,
  VolunteerDto,
} from "@/api/appService";
import { ElForm } from "element-ui/types/form";
import VolunteerSelect from "@/components/VolunteerSelect/index.vue";

@Component({
  name: "EditApply",
  components: { VolunteerSelect },
})
export default class EditApply extends Vue {
  @Ref() readonly dataForm!: ElForm;
  @Ref() readonly selection!: VolunteerSelect;
  @Prop({ required: true })
  activityId!: number;

  @Prop({ required: false })
  activity!: any;

  defaultData: ActivityApplyCreateOrUpdateDto = {
    id: 0,
  };

  show = false;
  form: ActivityApplyCreateOrUpdateDto = { ...this.defaultData };
  btnDisabled = false;
  dynamicSignUpForm: ActivityApplyFormSchemaDto[] = [];

  get title() {
    if (this.dataId) {
      return `编辑报名信息 ${this.form.surname}`;
    } else {
      return "新建报名";
    }
  }

  get dynamicSignUpFields() {
    const duplicatedFieldNames = new Set(["Name", "PhoneNumber"]);
    const duplicatedLabels = new Set(["姓名", "手机", "手机号"]);

    return this.parseActivitySignUpFields().filter((field) => {
      const fieldName = field.filedName || "";
      const label = field.name || "";
      return (
        label &&
        !duplicatedFieldNames.has(fieldName) &&
        !duplicatedLabels.has(label)
      );
    });
  }

  @Watch("show")
  async onShowChange(value: boolean) {
    console.log("activityId:", this.activityId);
    if (value) {
      await api.activityApply.getForEdit({ id: this.form!.id }).then((res) => {
        this.form = res.data!;
        this.form.activityId = this.activityId;
        this.syncDynamicSignUpForm();
      });
    } else {
      this.form = { ...this.defaultData };
      this.dynamicSignUpForm = [];
    }
    this.$nextTick(() => {
      this.dataForm.clearValidate();
    });
  }

  async save() {
    console.log(this.form);
    this.btnDisabled = true;
    (this.$refs.dataForm as any).validate(async (valid: boolean) => {
      if (valid && this.validateDynamicSignUpForm()) {
        this.form.signUpFormSchemaJson = this.getDynamicSignUpFormJson();
        if (this.dataId) {
          await api.activityApply.update({
            body: { ...this.form },
          });
        } else {
          await api.activityApply.create({
            body: { ...this.form },
          });
        }
        this.show = false;
        this.$message.success("更新成功");
        this.$emit("onSave");
        this.btnDisabled = false;
      } else {
        this.$message.error("请检查表单！");
        this.btnDisabled = false;
      }
    });
  }

  cancel() {
    this.show = false;
  }

  handleDialogClose(done: () => void) {
    this.cancel();
    done();
  }

  selectVolunteer() {
    this.selection.show = true;
  }

  async onSelect(user: VolunteerDto) {
    console.log(user);
    this.form!.userId = user.userId;
    this.form!.surname = user.user?.surname;
    this.form!.phoneNumber = user.user?.phoneNumber;
  }

  async autoFillVolunteerByPhone() {
    const phone = this.form.phoneNumber?.trim();
    if (!phone || !/^1[345789]\d{9}$/.test(phone)) {
      return;
    }

    try {
      const user = await api.user.getByMobilePhone({ mobilePhone: phone });
      if (!user?.id) {
        this.form.userId = undefined;
        return;
      }

      const volunteerResult = await api.volunteer.getAll({
        volunteerPhone: phone,
        status: VolunteerStatus.Approved,
        skipCount: 0,
        maxResultCount: 1,
      });

      const volunteer = volunteerResult?.items?.[0];
      if (!volunteer?.userId) {
        this.form.userId = undefined;
        return;
      }

      this.form.userId = volunteer.userId;
      this.form.surname =
        volunteer.user?.surname ||
        user.surname ||
        user.name ||
        this.form.surname;
      this.form.phoneNumber = user.phoneNumber || phone;
    } catch (error) {
      this.form.userId = undefined;
    }
  }

  parseActivitySignUpFields() {
    if (this.activity?.signUpFormSchemas?.length) {
      return this.activity.signUpFormSchemas as ActivitySignUpFormSchemaDto[];
    }

    if (!this.activity?.signUpFormSchemaJson) {
      return [] as ActivitySignUpFormSchemaDto[];
    }

    try {
      const parsed = JSON.parse(this.activity.signUpFormSchemaJson);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [] as ActivitySignUpFormSchemaDto[];
    }
  }

  parseApplySignUpValues() {
    if (!this.form.signUpFormSchemaJson) {
      return [] as ActivityApplyFormSchemaDto[];
    }

    try {
      const parsed = JSON.parse(this.form.signUpFormSchemaJson);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [] as ActivityApplyFormSchemaDto[];
    }
  }

  syncDynamicSignUpForm() {
    const savedValues = this.parseApplySignUpValues();
    this.dynamicSignUpForm = this.dynamicSignUpFields.map((field) => {
      const savedValue = savedValues.find((item) => item.name === field.name);
      return {
        name: field.name,
        value: savedValue?.value || "",
      };
    });
  }

  getDynamicFieldValue(index: number) {
    return this.dynamicSignUpForm[index]?.value || "";
  }

  updateDynamicFieldValue(index: number, value: string) {
    if (!this.dynamicSignUpForm[index]) {
      this.$set(this.dynamicSignUpForm, index, {
        name: this.dynamicSignUpFields[index]?.name,
        value: "",
      });
    }

    this.dynamicSignUpForm[index].value = value;
  }

  validateDynamicSignUpForm() {
    for (let index = 0; index < this.dynamicSignUpFields.length; index++) {
      const field = this.dynamicSignUpFields[index];
      const value = this.dynamicSignUpForm[index]?.value;
      if (field.required && !value) {
        this.$message.error(`请填写${field.name}`);
        this.btnDisabled = false;
        return false;
      }
    }

    return true;
  }

  getDynamicSignUpFormJson() {
    const values = this.dynamicSignUpForm
      .filter((item) => item.name)
      .map((item) => ({
        name: item.name,
        value: item.value || "",
      }));

    return values.length ? JSON.stringify(values) : undefined;
  }

  linkRule = {
    surname: [
      {
        required: true,
        message: "请输入姓名",
        trigger: "blur",
      },
    ],
    phoneNumber: [
      {
        required: true,
        message: "请输入电话",
        trigger: "blur",
      },
    ],
  };
}
